import router from './router'
import globals from '@/globals'
import { getCookie } from '@/utils/cookieFunctions'
import { getRole } from '@/utils/jwtOperations'

const whiteListName = ['OturumAc', 'Katil', 'Kayit', 'HocaKayit', 'Hoca-Kayit', 'BayanHocaKayit',
  'Bayan-Hoca-Kayit', 'BayanKayit', 'Bayan-Kayit', 'UzaktanOturumAc', 'UluedKayit', 'UluedBayanOgrenciKayit', 'Sifremiunuttum', 'SifreSifirla',
  'EskiGirisYap', 'EskiKayitOl', 'EskiTanitim', 'EskiHesabim', 'UzaktanEgitimKayit', 'YuzyuzeEgitimKayit']

router.afterEach((to, from) => {
  const splashScreen = document.querySelector('.app-splash-screen')
  if (splashScreen) {
    splashScreen.style.opacity = 0
    setTimeout(() => splashScreen && splashScreen.parentNode.removeChild(splashScreen), 300)
  }
  if (window.layoutHelpers && window.layoutHelpers.isSmallScreen() && !window.layoutHelpers.isCollapsed()) {
    setTimeout(() => window.layoutHelpers.setCollapsed(true, true), 10)
  }
  globals().scrollTop(0, 0)
})

router.beforeEach((to, from, next) => {
  if (to.path === 'swagger') {
    document.body.classList.add('app-loading')
    setTimeout(() => next(), 10)
  } else {
    if (to.path) {
      if (to.path === '/404') {
        document.body.classList.add('app-loading')
        setTimeout(() => next(), 10)
      } else {
        if (getCookie('refreshToken') || getCookie('token')) {
          const yetki = getRole()
          if (to.meta && to.meta[0]) {
            const yetkiler = to.meta[0].Roles
            if (yetkiler) {
              if (yetkiler.indexOf(yetki) !== -1) {
                document.body.classList.add('app-loading')
                setTimeout(() => next(true), 10)
              } else {
                document.body.classList.add('app-loading')
                setTimeout(() => next({ path: '/' }), 10)
              }
            } else {
              document.body.classList.add('app-loading')
              setTimeout(() => next(true), 10)
            }
          } else {
            document.body.classList.add('app-loading')
            setTimeout(() => next(true), 10)
          }
          document.body.classList.add('app-loading')
          setTimeout(() => next(true), 10)
        } else {
          if (whiteListName.indexOf(to.name) !== -1) {
            document.body.classList.add('app-loading')
            setTimeout(() => next(true), 10)
          } else {
            document.body.classList.add('app-loading')
            setTimeout(() => next({
              path: '/giris',
              query: { returnUrl: to.path }
            }), 10)
          }
        }
      }
    } else {
      document.body.classList.add('app-loading')
      setTimeout(() => next({ path: '/404' }), 10)
    }
  }
})
